import { Button, FormControl } from '@material-ui/core'
import { sum } from 'lodash'
import React, { useMemo } from 'react'

import { PolicyRule_ProrationKindEnum } from 'src/api/gen'
import { getTranslation } from 'src/commons/i18n'

export const useProrationActions = function (
  prorationKind: PolicyRule_ProrationKindEnum | '',
  prorationAreasMapping: [string, number][],
  prorationTimeSpentReportArea: string,
  openConfirm: () => void,
  handleClose: () => void
) {
  const prorationSum = useMemo(
    () => sum(prorationAreasMapping.map(([_, proration]) => proration)),
    [prorationAreasMapping]
  )
  const prorationKeys = useMemo(
    () => new Set(prorationAreasMapping.filter((mapping) => mapping[0] !== '').map((mapping) => mapping[0])),
    [prorationAreasMapping]
  )

  const onClick = useMemo(() => {
    switch (prorationKind) {
      case PolicyRule_ProrationKindEnum.areas: {
        if (prorationSum != 100 || prorationKeys.size != prorationAreasMapping.length) {
          return openConfirm
        } else {
          return handleClose
        }
      }
      case PolicyRule_ProrationKindEnum.time_spent:
      default:
        return handleClose
    }
  }, [prorationKind, prorationSum, prorationAreasMapping, prorationTimeSpentReportArea])
  // prorationTimeSpentReportArea dependency is needed to prevent onClick to be stuck in the past on an area change

  return { disabled: onClick === openConfirm, onClick }
}

interface IProrationActionsProps {
  close: () => void
  handleClose: () => void
  openConfirm: () => void
  prorationAreasMapping: [string, number][]
  prorationKind: PolicyRule_ProrationKindEnum | ''
  prorationTimeSpentReportArea: string
}

export const ProrationActions = function (props: IProrationActionsProps) {
  const { t } = getTranslation()
  const { disabled, onClick } = useProrationActions(
    props.prorationKind,
    props.prorationAreasMapping,
    props.prorationTimeSpentReportArea,
    props.openConfirm,
    props.handleClose
  )

  return (
    <>
      <Button variant="contained" color="primary" onClick={props.close}>
        {t<string>('buttons.close')}
      </Button>
      <FormControl>
        <Button variant="contained" color="primary" onClick={onClick} disabled={disabled}>
          {t<string>('buttons.configure-events.save')}
        </Button>
      </FormControl>
    </>
  )
}
